<!--
 * 店长提示弹窗组件
 * @description 预约成功页店长提示弹窗，用于首次到店或首次约某教练时显示
 * @author suu
 * @date 2026-07-06
-->
<template>
  <van-action-sheet
    v-model="showPop"
    :safe-area-inset-bottom="false"
    class="shop-tips-pop-wrap"
  >
    <div class="shop-tips-pop" v-if="shopInfo">
      <div class="pop-box">
        <img
          src="https://cdnvue.gymcity.com.cn/uploads/appo-suc-shopmanage-bg"
          alt=""
          class="pop-bg"
        />
        <van-icon name="close" class="pop-close" @click="showPop = false" />
        <div class="pop-title">
          <div class="title-name"
            >您好，我是店长{{ shopInfo.main_manager.name }}</div
          >
          <div class="title-text">
            <span v-if="shopInfo.shop_ordered_count == 1"
              >欢迎来{{ shopInfo.class_shopname }}上课！</span
            >
            <span v-else-if="shopInfo.coach_ordered_count == 1"
              >又来{{ shopInfo.class_shopname }}训练啦！</span
            >
          </div>
        </div>
        <img class="pop-shop-img" :src="shopInfo.main_manager.app_img" alt="" />
        <img
          class="pop-contant-bg"
          src="https://cdnvue.gymcity.com.cn/uploads/appo-suc-shopmanage-wrap"
          alt=""
        />
        <div class="pop-content">
          <div class="content-left">
            <div class="left-num">1</div>
            <div class="left-line"></div>
            <div class="left-num">2</div>
          </div>
          <div class="content-right">
            <template v-if="shopInfo.shop_ordered_count == 1">
              <div class="right-text"
                >第一次到这边上课，肯定会有些不熟悉，不用担心。</div
              >
              <div class="right-text"
                >场馆环境、教练带训有任何不合心意、看不明白的地方，随时找我，我会帮您处理妥当！</div
              >
            </template>
            <template v-else-if="shopInfo.coach_ordered_count == 1">
              <div class="right-text"
                >这是您第一次约<span>{{ shopInfo.class_coachname }}</span
                >教练的课，我会全程留意您的训练感受。</div
              >
              <div class="right-text"
                >如果训练节奏、场馆环境有任何不习惯，随时和我说，我会马上帮您调整！</div
              >
            </template>
          </div>
        </div>
        <div
          class="shop-wxwork"
          :class="{ 'shop-wxwork-shop': shopInfo.shop_ordered_count == 1 }"
          @click="handleLinkShop"
        >
          <img
            src="https://cdnvue.gymcity.com.cn/uploads/pub-icon-wxwork"
            alt=""
          />
          <div class="wxwork-text">微信联系店长</div>
          <div class="wxwork-btn"
            >店长·{{ shopInfo.main_manager.name }}
            <van-icon name="arrow" class="btn-icon" />
          </div>
        </div>
        <div class="pop-btn-box">
          <div
            class="pop-btn-box-item user-btn"
            v-if="shopInfo.has_guide && shopInfo.shop_ordered_count == 1"
            @click="handleOpenGuide(shopInfo.shop_id)"
            >查看到店指引</div
          >
          <div
            class="pop-btn-box-item pop-btn-box-item-add user-btn"
            @click="handleClose"
          >
            我知道了
          </div>
        </div>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
/**
 * 店长提示弹窗组件
 * @description 预约成功页店长提示弹窗，用于首次到店或首次约某教练时显示
 */
export default {
  name: 'ReservationsShopTipsPop',

  props: {
    /**
     * 是否显示弹窗
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 店长提示信息
     * @property {Object} main_manager - 店长信息
     * @property {string} main_manager.name - 店长姓名
     * @property {string} main_manager.image - 店长头像
     * @property {string} main_manager.id - 店长ID
     * @property {number} shop_ordered_count - 该门店预约次数
     * @property {number} coach_ordered_count - 该教练预约次数
     * @property {string} class_shopname - 门店名称
     * @property {string} class_coachname - 教练名称
     * @property {number} shop_id - 门店ID
     */
    shopInfo: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    /**
     * 弹窗显示状态
     */
    showPop: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    /**
     * 处理关闭弹窗
     */
    handleClose() {
      this.$emit('close')
    },

    /**
     * 处理查看到店指引
     * @param {number} shopId - 门店ID
     */
    handleOpenGuide(shopId) {
      this.$emit('openGuide', shopId)
    },

    /**
     * 处理联系店长
     */
    handleLinkShop() {
      this.$emit('linkShop')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.shop-tips-pop-wrap {
  background: transparent;

  .shop-tips-pop {
    width: 100%;
    box-sizing: border-box;
    padding-top: vw(30);

    .pop-box {
      width: 100%;
      box-sizing: border-box;
      background: #f9f9f9;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: vw(16) vw(16) 0px 0px;
      padding-top: vw(13);
      padding-bottom: vw(40);
      // padding-bottom: calc(#{vw(10)} + constant(safe-area-inset-bottom));
      // padding-bottom: calc(#{vw(10)} + env(safe-area-inset-bottom));
      position: relative;
      z-index: 1;

      .pop-bg {
        width: 100%;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }

      .pop-close {
        position: absolute;
        top: vw(-30);
        right: vw(15);
        font-size: vw(24);
        color: #fff;
      }

      .pop-title {
        width: 100%;
        box-sizing: border-box;
        padding: 0 vw(20);
        color: #fff;
        line-height: vw(22);

        .title-name {
          font-size: vw(14);
        }

        .title-text {
          font-size: vw(15);
          font-weight: 500;
        }
      }

      .pop-shop-img {
        width: vw(120);
        position: absolute;
        right: vw(20);
        top: vw(-21);
        z-index: -1;
      }

      .pop-contant-bg {
        width: vw(355);
        position: absolute;
        top: vw(57);
        z-index: 0;
      }

      .pop-content {
        width: 100%;
        box-sizing: border-box;
        margin-top: vw(31);
        padding: 0 vw(35);
        display: flex;
        // align-items: center;
        justify-content: center;
        z-index: 1;

        .content-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: vw(16);
          margin-top: vw(4);

          .left-num {
            width: vw(26);
            height: vw(26);
            border-radius: 50%;
            background: #ff2270;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: vw(13);
            color: #ffffff;
          }

          .left-line {
            width: vw(3);
            height: vw(34);
            margin: vw(3) 0;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              width: vw(3);
              height: vw(3);
              border-radius: 50%;
              background-color: #ff2270;
              box-shadow: 0 vw(6) 0 #ff2270, 0 vw(12) 0 #ff2270,
                0 vw(18) 0 #ff2270, 0 vw(24) 0 #ff2270, 0 vw(30) 0 #ff2270;
            }
          }
        }

        .content-right {
          flex: 1;
          word-break: break-all;

          .right-text {
            font-size: vw(15);
            color: #050b27;
            line-height: vw(24);

            & + .right-text {
              margin-top: vw(16);
            }

            span {
              color: #ff2270;
            }
          }
        }
      }

      .shop-wxwork {
        width: vw(315);
        height: vw(48);
        box-sizing: border-box;
        margin-top: vw(46);
        padding: 0 vw(16);
        background: #f7f7f7;
        border-radius: vw(6);
        border: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        z-index: 1;

        &.shop-wxwork-shop {
          margin-top: vw(22);
        }

        img {
          width: vw(24);
          margin-right: vw(10);
        }

        .wxwork-text {
          font-weight: 600;
          font-size: vw(15);
          color: #050b27;
        }

        .wxwork-btn {
          flex: 1;
          font-weight: 300;
          font-size: 12px;
          color: rgba($color: #050b27, $alpha: 0.8);
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .btn-icon {
            font-size: vw(10);
            margin-left: vw(9);
          }
        }
      }

      .pop-btn-box {
        width: 100%;
        box-sizing: border-box;
        padding: 0 vw(10);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: vw(44);

        .pop-btn-box-item {
          width: vw(157);
          height: vw(48);
          box-sizing: border-box;
          background: #ffffff;
          border-radius: vw(24);
          font-weight: 500;
          font-size: vw(16);
          color: #050b27;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: vw(8);
        }

        .pop-btn-box-item-add {
          flex: 1;
          background: #ff2270;
          color: #fff;
          margin-right: 0;
        }
      }
    }
  }
}
</style>
